export default __webpack_public_path__ + "static/1245-1f130963ee406efb2520e19ce318a14b.gif";